import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/es/integration/react'
import { Router, Route, Switch, Navigation } from 'react-router-dom'
import history from 'utils/history'
import privateComponent from 'utils/hocs/privateComponent'
import publicComponent from 'utils/hocs/publicComponent'
import PublicLayout from 'containers/layouts/PublicLayout'
import PublicBlankLayout from 'containers/layouts/PublicBlankLayout'
import PrivateLayout from 'containers/layouts/PrivateLayout'

import HomePublic from 'containers/publicPages/home'
import SatuanPendidikanPublic from 'containers/publicPages/satuanPendidikan';
import PenyediaPublic from 'containers/publicPages/penyedia';
import VisitSiplah from 'containers/publicPages/visitSiplah'
import LearnSiplah from 'containers/publicPages/learnSiplah'
import FollowSiplah from 'containers/publicPages/followSiplah'
import AssistanceGoverment from 'containers/publicPages/assistanceGoverment'
import AnnouncementPublic from 'containers/publicPages/announcement'
import InfoBeritaPublic from 'containers/publicPages/infoBerita'
import CategoryPublic from 'containers/publicPages/infoBerita/category'
import InfoBeritaDetailPublic from 'containers/publicPages/infoBerita/detail'

import Login from 'containers/login/Login'
import Forgot from 'containers/login/Forgot'
import NotFound from 'containers/NotFound'
import Dashboard from 'containers/pages/dashboard'
import Mitra from 'containers/pages/mitra'
import MitraForm from 'containers/pages/mitra/Form'
import News from 'containers/pages/news'
import NewsDetail from 'containers/pages/news/Detail'
import NewsForm from 'containers/pages/news/Form'
import Goverment from 'containers/pages/goverment'
import GovermentForm from 'containers/pages/goverment/Form'
import Category from 'containers/pages/categories'
// import CategoryList from 'containers/pages/categories/List'
// import CategoryForm from 'containers/pages/categories/Form'
import SocialMedia from 'containers/pages/socialMedia'
import SocialMediaForm from 'containers/pages/socialMedia/Form'
import VideoList from 'containers/pages/video'
import VideoListForm from 'containers/pages/video/Form'
import FaqCategory from 'containers/pages/faq/categories'
import FaqCategoryForm from 'containers/pages/faq/categories/Form'
import FaqList from 'containers/pages/faq/'
import FaqListForm from 'containers/pages/faq//Form'
// import SocialMediaForm from 'containers/pages/socialMedia/Form'
import MenuList from 'containers/pages/menu/'
import MenuForm from 'containers/pages/menu/Form'
import SlideshowList from 'containers/pages/slideshow/'
import SlideshowForm from 'containers/pages/slideshow/Form'
import UserList from 'containers/pages/users/'
import UserListForm from 'containers/pages/users/Form'

const PublicRoute = (props) => {
  const {
    component: Component,
    redirect,
    redirectPath,
    ...rest
  } = props
  
  const PublicLayoutView = publicComponent(PublicLayout, redirect, redirectPath)

  return (
    <Route
      {...rest}
      render={matchProps => (
        <PublicLayoutView>
          <Component {...matchProps} />
        </PublicLayoutView>
      )}
    />
  )
}

const PublicRouteBlank = (props) => {
  const {
    component: Component,
    redirect,
    redirectPath,
    ...rest
  } = props

  const PublicBlankLayoutView = publicComponent(PublicBlankLayout, redirect, redirectPath)

  return (
    <Route
      {...rest}
      render={matchProps => (
        <PublicBlankLayoutView>
          <Component {...matchProps} />
        </PublicBlankLayoutView>
      )}
    />
  )
}

const PrivateRoute = ({ component: Component, ...rest }) => {
  const PrivateLayoutView = privateComponent(PrivateLayout)

  return (
    <Route
      {...rest}
      render={matchProps => (
        <PrivateLayoutView>
          <Component {...matchProps} />
        </PrivateLayoutView>
      )}
    />
  )
}

const Root = ({ store, persistor }) => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>

      <Router history={history}>
        <Switch>
          <PublicRoute exact path="/" component={HomePublic} />
          <PublicRoute exact path="/satuan-pendidikan" component={SatuanPendidikanPublic}/>
          <PublicRoute exact path="/penyedia-barang-jasa" component={PenyediaPublic}/>
          <PublicRoute exact path="/info-berita" component={InfoBeritaPublic}/>
          <PublicRoute exact path="/info-berita/:id" component={CategoryPublic} />
          <PublicRoute exact path="/info-berita/:id/detail" component={InfoBeritaDetailPublic}/>
          {/* <PublicRoute exact path="/kunjungi" component={VisitSiplah} />
          <PublicRoute exact path="/pelajari" component={LearnSiplah} />
          <PublicRoute exact path="/ikuti" component={FollowSiplah} />
          <PublicRoute exact path="/bantuan-pemerintah" component={AssistanceGoverment} /> */}

          <PublicRouteBlank exact redirect path="/login" component={Login} />
          <PublicRouteBlank exact redirect path="/reset" component={Forgot} />

          <PrivateRoute exact path="/dashboard" component={Dashboard} />

          {/* <PrivateRoute exact path="/mitra" component={Mitra} />
          <PrivateRoute exact  path="/mitra/add" component={MitraForm} />
          <PrivateRoute exact path="/mitra/:id/edit" component={MitraForm} /> */}

          <PrivateRoute exact path="/news" component={News} />
          <PrivateRoute exact path="/news/add" component={NewsForm} />
          <PrivateRoute exact path="/news/:id/edit" component={NewsForm} />
          <PrivateRoute exact path="/news/:id/detail" component={NewsDetail} />

          {/* <PrivateRoute exact path="/goverment" component={Goverment} />
          <PrivateRoute exact path="/goverment/add" component={GovermentForm} /> */}

          <PrivateRoute exact path="/category" component={Category} />
          <PrivateRoute exact path="/category/add" component={Category} />
          <PrivateRoute exact path="/category/:id/edit" component={Category} />

          {/* <PrivateRoute exact path="/social-media" component={SocialMedia} />
          <PrivateRoute exact path="/social-media/add" component={SocialMediaForm} />
          <PrivateRoute exact path="/social-media/:id/edit" component={SocialMediaForm} />

          <PrivateRoute exact path="/video" component={VideoList} />
          <PrivateRoute exact path="/video/add" component={VideoListForm} />
          <PrivateRoute exact path="/video/:id/edit" component={VideoListForm} />

          <PrivateRoute exact path="/faq/category" component={FaqCategory} />
          <PrivateRoute exact path="/faq/category/add" component={FaqCategoryForm} />
          <PrivateRoute exact path="/faq/category/:id/edit" component={FaqCategoryForm} />

          <PrivateRoute exact path="/faq/list" component={FaqList} />
          <PrivateRoute exact path="/faq/list/add" component={FaqListForm} />
          <PrivateRoute exact path="/faq/list/:id/edit" component={FaqListForm} />

          <PrivateRoute exact path="/menu" component={MenuList} />
          <PrivateRoute exact path="/menu/add" component={MenuForm} />
          <PrivateRoute exact path="/menu/:id/edit" component={MenuForm} />

          <PrivateRoute exact path="/slideshow" component={SlideshowList} />
          <PrivateRoute exact path="/slideshow/add" component={SlideshowForm} />
          <PrivateRoute exact path="/slideshow/:id/edit" component={SlideshowForm} /> */}

          <PrivateRoute exact path="/user/list" component={UserList} />
          <PrivateRoute exact path="/user/add" component={UserListForm} />
          <PrivateRoute exact path="/user/:id/edit" component={UserListForm} />

          <PublicRouteBlank exact strict component={NotFound} />
        </Switch>
      </Router>

    </PersistGate>
  </Provider>
)

Root.propTypes = {
  store: PropTypes.shape().isRequired,
  persistor: PropTypes.shape().isRequired,
}

PrivateRoute.propTypes = {
  component: PropTypes.any,
}

PublicRouteBlank.propTypes = {
  component: PropTypes.any,
  redirect: PropTypes.bool,
  redirectPath: PropTypes.string,
}

PublicRoute.propTypes = {
  component: PropTypes.any,
  redirect: PropTypes.bool,
  redirectPath: PropTypes.string,
}

export default Root
